import { __assign } from "tslib";
// DS: CR18E
import React, { useContext } from 'react';
import get from 'lodash/get';
import { Trans, useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { NotificationType } from '../../Notifications/redux/types';
import Notification from '../../Notifications/Notification';
import SystemNotification from '../../SystemNotification';
import AddToFaveIcon from '@wix/da-ds/pkg/Icons/24x24/AddedToFav';
import RemoveFaveIcon from '@wix/da-ds/pkg/Icons/24x24/RemovedFromFav';
import ErrorIcon from '@wix/da-ds/pkg/Icons/CloseBold';
import { BiEventType, BiDataHook } from '@wix/da-bi/pkg/constants';
import { getDeviationResourceType } from '../../DeviationViews/_helpers';
import { getDeviationNotificationQueue } from '../../DeviationPage/redux/helpers';
import { ActionBarContext } from '../../ActionBar/ActionBarContext';
var FaveNotification = function (props) {
    var success = props.success, id = props.id, type = props.type, isFavourite = props.isFavourite, deviation = props.deviation, queueName = props.queueName, addNotification = props.addNotification, removeNotification = props.removeNotification, onAddToCollection = props.onAddToCollection, currentUser = props.currentUser;
    var t = useTranslation().t;
    var actionBarType = useContext(ActionBarContext);
    var deviationBiData = {
        itemid: deviation.deviationId,
        typeid: getDeviationResourceType(deviation),
        creatorid: get(deviation, 'author.useridUuid'),
    };
    var renderTitle = function () {
        var wasRemoved = isUndo() || !isFavourite;
        if (!success) {
            return t("faveNotification.error.".concat(wasRemoved ? 'removedFromFaves' : 'addedToFaves', ".v2"));
        }
        if (wasRemoved) {
            return (
            // prettier-ignore
            React.createElement(Trans, { i18nKey: "faveNotification.notification.removedFromFaves.v2" },
                "Removed from ",
                React.createElement("a", { href: Url.userGalleryLink({
                        username: currentUser.username,
                        gallectionType: 'collection'
                    }) }, "Favourites")));
        }
        return (
        // prettier-ignore
        React.createElement(Trans, { i18nKey: "faveNotification.notification.addedToFaves.v2" },
            "Added to ",
            React.createElement("a", { href: Url.userGalleryLink({
                    username: currentUser.username,
                    gallectionType: 'collection'
                }) }, "Favourites")));
    };
    var isUndo = function () {
        return type === NotificationType.FaveUndo;
    };
    var onCollect = function () {
        onAddToCollection && onAddToCollection(deviation, queueName, actionBarType);
        removeNotification(id);
    };
    return (React.createElement(Notification, { id: id, queueName: queueName, cardComponent: SystemNotification, cardProps: {
            iconComponent: success
                ? isUndo() || !isFavourite
                    ? RemoveFaveIcon
                    : AddToFaveIcon
                : ErrorIcon,
            backgroundDeviation: deviation,
            actions: [
                !isUndo() &&
                    isFavourite && {
                    type: 'positive',
                    label: t('faveNotification.notification.action.addToCollection'),
                    biData: __assign({ evid: BiEventType.POPUP_CLICK_ADD_TO_COLLECTION, sectionname: 'notificationTooltip' }, deviationBiData),
                    onClick: onCollect,
                },
            ],
            dataHook: BiDataHook.FAVES_POPUP,
        }, onClose: queueName === getDeviationNotificationQueue(deviation) &&
            success &&
            isFavourite &&
            !isUndo()
            ? function () { return addNotification(queueName, 'commentReminder', {}); }
            : undefined },
        React.createElement("span", { "data-hook": BiDataHook.FAVES_POPUP_MESSAGE }, renderTitle())));
};
FaveNotification.displayName = 'FaveNotification';
export default FaveNotification;
//# sourceMappingURL=FaveNotification.js.map